import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../../api.service'
import type { Plugin } from '../plugin'

/**
 * Stops a running process by terminating its ECS task via the
 * {@link Api.stop} method
 */
export const executeStopProcess = store.effects.create(
  (feature: Plugin['feature'], api: Api) =>
    feature.actions.stopProcess.relay((forwardTo, { processId }) =>
      api.meFeature.contexts.selectors.zoneContext.asObservable.pipe(
        rxjs.take(1),
        rxjs.switchMap(context => {
          if (!context) {
            return rxjs.of({
              error: { error: new Error('No zone context available') },
            })
          }
          return api.stop(context, processId).pipe(
            rxjs.map(() => ({ success: { response: undefined } })),
            rxjs.catchError(error => rxjs.of({ error: { error } })),
          )
        }),
      ),
    ).asObservable,
)
